import { render } from "./step1.vue?vue&type=template&id=cb85cfd4&scoped=true"
import script from "./step1.vue?vue&type=script&lang=js"
export * from "./step1.vue?vue&type=script&lang=js"

import "./step1.vue?vue&type=style&index=0&id=cb85cfd4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb85cfd4"]])

export default __exports__